<template>
    <div class="or-admin-product-constructor-image">
        <div class="images" :style="[options.style, 'display: flex']">
            <img :src="img.src" class="image" :style="img.style" v-for="img in options.images" :key="img.id"/>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        options: Object,
    },
}
</script>

<style scoped>
    .or-admin-product-constructor-image {
        position: relative;
    }
</style>